import { makeStyles } from "@material-ui/core";

export const useTravelerStyles = makeStyles(() => ({
  baseBorder: {
    borderStyle: "solid",
    borderWidth: "1px",
  },
}));
